import { Navbar } from './modules/layout/Navbar'
import { Content } from './modules/layout/Content'
import { Titlebar } from './modules/layout/Titlebar'
import { Catalogue } from './modules/object/Catalogue'

const C = {
    Navbar,
    Content,
    Titlebar,

    Catalogue,
}
export default C